// extracted by mini-css-extract-plugin
export default {"overlay":"AddressFormMenu_overlay__oPCPC","menu":"AddressFormMenu_menu__f5e-i"};